import SpendChart from "../SpendChart";
import Header from "./Header";

const SpendingChart = ({ scenario, client }: any) => {
  return (
    <div>
      <Header client={client} scenario={scenario} page="Spending" />
      <SpendChart settings={scenario} client={client} print />
    </div>
  );
};

export default SpendingChart;
